export const juniorAccountantResume = `
【職務概要】
私は経理職として3年の経験を持ち、月次・年次決算業務、現預金管理、債権債務管理、経費精算処理などの財務会計業務に携わってまいりました。特に資金管理と債権回収においては、効率的な管理フローの構築に貢献し、回収率の向上に寄与した実績があります。

簿記2級の資格を活かし、一般会計処理の基礎から応用まで幅広く対応できるスキルを身につけており、会計ソフトウェア（弥生会計・PCA会計・MFクラウド）の操作にも精通しています。Microsoft Excelについても、複雑な関数やピボットテーブルを活用した業績分析・レポート作成ができます。

業界動向や会計基準の変更にも常に注目し、自己研鑽に努めています。昨今のDX推移における経理業務の効率化・自動化の流れを理解し、新たなシステム導入やデジタルツールの活用にも積極的に取り組んでいます。将来的には国際会計基準（IFRS）の知識を深め、グローバルな経理実務にも対応できる専門性を高めていく意向です。

【職務経歴】
・株式会社Algomaticファイナンシャル
 〇会社概要：総合金融サービス企業。従業員数約300名。資産運用・投資信託業務を展開
 〇就業期間：2022年4月～現在
 〇職務内容：
  ・月次・年次決算業務の補助（仕訳入力、残高照合、決算書類作成補助）
  ・経費精算業務（社員約300名分の経費精算処理、承認フロー管理）
  ・債権管理（売掛金管理、入金消込、滞留債権管理）
  ・各種税務申告書類の作成補助
 〇具体的な成果：
  ・経費精算システムの導入プロジェクトに参画し、承認フロー構築とマニュアル作成を担当、処理時間を月間約15時間削減
  ・売掛金の回収管理プロセスを改善し、滞留債権を前年比30%削減
  ・月次決算の処理手順を標準化し、決算期間を7営業日から5営業日に短縮
 〇使用した技術・ツール：
  ・MFクラウド（会計ソフト）、Concur（経費精算システム）、Excel（VLOOKUPなどの関数活用）
 〇身につけたスキル・知識：
  ・金融業界特有の会計処理に関する知識
  ・内部統制に関する基礎知識
  ・経費精算システムの構築・運用ノウハウ

・株式会社Algomaticビジネスサービス
 〇会社概要：中小企業向け経理・総務アウトソーシングサービス。顧客企業約50社
 〇就業期間：2021年4月～2022年3月
 〇職務内容：
  ・複数クライアント企業（主に10社担当）の月次決算業務
  ・伝票入力、現預金管理、固定資産管理
  ・決算書類作成、税理士との連携
 〇具体的な成果：
  ・担当企業10社の月次決算を平均納期より2日早く完了
  ・顧客からの問い合わせ対応マニュアルを作成し、チーム内で共有
  ・Excel自動集計シートを作成し、作業時間を20%削減
 〇使用した技術・ツール：
  ・弥生会計、PCA会計、Excel、クラウドストレージ（Dropbox, Google Drive）
 〇身につけたスキル・知識：
  ・複数業種の会計処理の違いに関する知識
  ・顧客対応・コミュニケーションスキル
  ・効率的な業務改善手法

【受賞・表彰歴】
・2023年度 四半期MVP（株式会社Algomaticファイナンシャル）
 〇内容：経費精算システム導入プロジェクトにおける貢献が評価
 〇選定理由：期限内の完了と運用マニュアルの徹底した整備

・2022年度 新人賞（株式会社Algomaticファイナンシャル）
 〇内容：入社1年目でありながら、迅速な業務習得と改善提案が評価

【資格】
・日商簿記2級（2021年6月取得）
・ファイナンシャル・プランニング技能士3級（2022年9月取得）
・MOS Excel Expert（2021年3月取得）
・経理実務検定2級（2023年3月取得）

【マネジメント経験】
・株式会社Algomaticファイナンシャルにて新入社員1名の指導担当（2023年4月～9月）
 〇内容：日次・月次業務の研修、売掛金管理業務の引継ぎ
 〇成果：3ヶ月で基本業務を独立して遂行できるレベルまで育成

・経費精算システム導入プロジェクトのサブリーダー（2023年1月～3月）
 〇内容：部門担当者5名との調整、要件定義補助、テスト実施
 〇成果：予定通りの導入完了、ユーザー満足度90%達成

【語学力】
・英語：TOEIC 680点（2022年8月）
 〇ビジネスメール・資料の読解可能
 〇海外取引先との基本的なメールのやり取り経験あり
 〇財務数値の英文レポート作成経験あり
` as const;
